import { render, staticRenderFns } from "./ClosedProp.vue?vue&type=template&id=8a7ea104&"
import script from "./ClosedProp.vue?vue&type=script&lang=js&"
export * from "./ClosedProp.vue?vue&type=script&lang=js&"
import style0 from "./ClosedProp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports